import React from 'react';

import styles from '../styles/MobileMenu.module.scss';
import { logout_button } from '../vm/HeaderStore';

interface MobileMenuLogoutSectionProps {
  is_authenticated: boolean;
  onLogout: () => void;
}

function MobileMenuLogoutSection({
  is_authenticated,
  onLogout,
}: Readonly<MobileMenuLogoutSectionProps>): React.ReactElement | null {
  if (!is_authenticated) {
    return null;
  }

  return (
    <button type="button" className={styles['logout']} onClick={onLogout}>
      {logout_button}
    </button>
  );
}

export default MobileMenuLogoutSection;
